export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1975_20570)">
                <path
                    d="M30.9375 8.375H5.0625C4.13052 8.375 3.375 9.13052 3.375 10.0625V26.9375C3.375 27.8695 4.13052 28.625 5.0625 28.625H30.9375C31.8695 28.625 32.625 27.8695 32.625 26.9375V10.0625C32.625 9.13052 31.8695 8.375 30.9375 8.375Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M24.75 20.75H29.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M24.75 24.125H29.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M20.25 11.75H7.875C7.25368 11.75 6.75 12.2537 6.75 12.875V24.125C6.75 24.7463 7.25368 25.25 7.875 25.25H20.25C20.8713 25.25 21.375 24.7463 21.375 24.125V12.875C21.375 12.2537 20.8713 11.75 20.25 11.75Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="27" cy="15.125" r="2.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1975_20570">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
